import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    IconButton,
    Typography,
    Alert
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { WarningIcon } from '../../../vectors/index';
import { useUpdateWotcStatus } from '../hooks/useUpdateWotcStatus';

type ChangeEmployerWotcStatusProps = {
    handleClose: () => void;
    item: any;
};

const ChangeEmployerWotcStatus: FC<ChangeEmployerWotcStatusProps> = ({
    handleClose,
    item,
}) => {
    const [errorText, setErrorText] = useState('')
    const { updateWotcStatus, isUpdateWotcStatusLoading } = useUpdateWotcStatus({ setErrorText })
    const handleSave = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message)
                handleClose();
            },
        };
        updateWotcStatus({
            wotc_enabled: item.company.wotc_enabled ? 'False' : 'True',
            company_id: item.company.id
        }, options)

        // toast.success('Pay rate updated successfully');
        // handleClose();
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <WarningIcon />
                <br />
                <Typography variant="h4" >
                    Are you sure?
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert severity='error'>{errorText}</Alert>}
                <Typography sx={{ marginBottom: "15px" }}>This will change the WOTC status for this Employer.</Typography>
                <LoadingButton
                    fullWidth
                    loading={isUpdateWotcStatusLoading}
                    disabled={isUpdateWotcStatusLoading}
                    sx={{ margintop: "10px" }}
                    variant="contained" color="error" onClick={handleSave}>
                    Change
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeEmployerWotcStatus;
